(function ($) {
    $.fn.truncate = function (l,s) {

        return this.each(function () {
            var myTruncate = $(this);
            var length = $(myTruncate).data('truncate-length') ? $(myTruncate).data('truncate-length') : l;
            var separator = $(myTruncate).data('truncate-separator') ? $(myTruncate).data('truncate-separator') : s;

            $(myTruncate).bind('change', function (event) {
                $(myTruncate).text(_.truncate($(myTruncate).text(), {
                    'length': length,
                    'separator': separator
                }));
            }).change();

            return myTruncate;
        });

    };

}(jQuery));
